<template>
  <div class="keyWords">
    <a-tabs type="card">
      <a-tab-pane key="1">
        <span slot="tab">
          关键词
        </span>
        <div class="headDiv">
          <a-select class="select" v-if="userInfo().role=='ROLE_SYSTEM'" v-model="searchData.bussdepid">
            <a-select-option value="">--请选择事业部--</a-select-option>
            <a-select-option v-for="item in businssDept" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
          &nbsp;&nbsp;
          <a-select class="select" v-model="searchData.bussdepType">
            <a-select-option value="">--请选择业务--</a-select-option>
            <a-select-option :value="item.value" v-for="item in bussdepType" :key="item.value">{{ item.value }}</a-select-option>
          </a-select>
          &nbsp;&nbsp;
          <a-select class="select" v-model="searchData.type">
            <a-select-option value="">--关键词类型--</a-select-option>
            <a-select-option value="1">审核关键词</a-select-option>
            <a-select-option value="2">质检关键词</a-select-option>
          </a-select>
          &nbsp;&nbsp;
          <a-select class="select" v-if="searchData.type==1" v-model="searchData.subtype">
            <a-select-option value="">--子类型--</a-select-option>
            <a-select-option value="1">敏感词白名单</a-select-option>
            <a-select-option value="2">审核敏感词</a-select-option>
            <a-select-option value="3">敏感词黑名单</a-select-option>
          </a-select>
          &nbsp;&nbsp;
          <a-input placeholder="关键词" v-model="searchData.keyword"></a-input>
          &nbsp;&nbsp;
          <a-button type="primary" @click="search">搜索</a-button>
          &nbsp;
          <a-button type="default" @click="reset">重置</a-button>
          &nbsp;
          <a-button type="primary" v-if="userInfo().role!='ROLE_SYSTEM'" @click="addNew">新增</a-button>
          &nbsp;
          <a-button type="primary" v-if="userInfo().role!='ROLE_SYSTEM'" @click="$refs.file.click()">批量导入</a-button>
          <a v-if="userInfo().role!='ROLE_SYSTEM'" href="http://jince-zbs.oss-cn-hangzhou.aliyuncs.com/template/%E5%85%B3%E9%94%AE%E8%AF%8D%E5%90%8D%E5%8D%95.xlsx">模版</a>
          <input type="file" ref="file" v-show="false" @change="chooseFile">
        </div>
        <a-table rowKey="id" :loading="loading" :dataSource="userList" :pagination="pagination" @change="handleTableChange">
          <a-table-column
            title="id"
            dataIndex="id"
          />
          <a-table-column
            title="关键词"
            dataIndex="keyword"
          />
          <a-table-column
            title="类型"
            dataIndex="type"
          ><template slot-scope="scope">
            {{ scope==1?'审核':'质检' }}
          </template></a-table-column>
          <a-table-column
            title="子类型"
            dataIndex="subtype"
          ><template slot-scope="scope">
            {{ filterScope(scope) }}
          </template></a-table-column>
          <a-table-column
            title="所属业务"
            dataIndex="bussdeptypeList"
          ><template slot-scope="scope">
            {{ mergeBuss(scope) }}
          </template>
          </a-table-column>
          <a-table-column
            title="添加时间"
            dataIndex="createTime"
          />
          <a-table-column
            title="添加方式"
            dataIndex="addWay"
          ><template slot-scope="scope">
            {{ scope==1?'手工添加':'批量导入' }}
          </template></a-table-column>
          <a-table-column
            title="操作人"
            dataIndex="userName"
          />
          <a-table-column
            title="状态"
            dataIndex="state"
          ><template slot-scope="state">
            {{ state==1?'正常':'移除' }}
          </template>
          </a-table-column>
          <a-table-column
            title="操作"
          ><template slot-scope="userid">
            <a-popconfirm v-show="userid.state == 1" title="确定删除该关键词？" @confirm="deleteOne(userid.id)">
              <a>移除</a>
            </a-popconfirm>&nbsp;
            <a @click="edit(userid)">编辑</a>
          </template>
          </a-table-column>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab">
          智能短句
        </span>
        <div class="headDiv">
          <a-select class="select" v-if="userInfo().role=='ROLE_SYSTEM'" v-model="searchData1.bussdepid">
            <a-select-option value="">--请选择事业部--</a-select-option>
            <a-select-option v-for="item in businssDept" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
          &nbsp;&nbsp;
          <a-select class="select" v-if="searchData1.type==1" v-model="searchData1.subtype">
            <a-select-option value="">--子类型--</a-select-option>
            <a-select-option value="1">敏感词白名单</a-select-option>
            <a-select-option value="2">审核敏感词</a-select-option>
            <a-select-option value="3">敏感词黑名单</a-select-option>
          </a-select>
          &nbsp;&nbsp;
          <a-input placeholder="关键词" v-model="searchData1.keyword"></a-input>
          &nbsp;&nbsp;
          <a-button type="primary" @click="search1">搜索</a-button>
          &nbsp;
          <a-button type="default" @click="reset1">重置</a-button>
        </div>
        <a-table rowKey="id" :loading="loading1" :dataSource="userList1" :pagination="pagination1" @change="handleTableChange1">
          <a-table-column
            title="id"
            dataIndex="id"
          />
          <a-table-column
            title="关键词"
            dataIndex="keyword"
          />
          <a-table-column
            title="类型"
            dataIndex="type"
          ><template slot-scope="scope">
            {{ scope==1?'审核':'质检' }}
          </template></a-table-column>
          <a-table-column
            title="添加时间"
            dataIndex="createTime"
          />
          <a-table-column
            title="操作人"
            dataIndex="userName"
          />
          <a-table-column
            title="状态"
            dataIndex="state"
          ><template slot-scope="state">
            {{ state==1?'正常':'移除' }}
          </template>
          </a-table-column>
          <a-table-column
            title="操作"
          ><template slot-scope="userid">
            <a-popconfirm v-show="userid.state == 1" title="确定删除该关键词？" @confirm="deleteOne(userid.id)">
              <a>移除</a>
            </a-popconfirm>&nbsp;
          </template>
          </a-table-column>
        </a-table>
      </a-tab-pane>
    </a-tabs>
    <a-modal
      :title="chooseItem.id?'修改':'新增'"
      width="600px"
      @ok="handleOk1"
      @cancel="visible1=false"
      :visible="visible1">
      <a-form-item
        label="关键词"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-input v-model="newData.keyword"></a-input>
      </a-form-item>
      <a-form-item
        label="类型"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-select class="select" v-model="newData.type">
          <a-select-option value="1">审核</a-select-option>
          <a-select-option value="2">质检</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="子类型"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
        v-show="newData.type==1">
        <a-select class="select" defaultValue="1" v-model="newData.subtype">
          <a-select-option value="1">敏感词白名单</a-select-option>
          <a-select-option value="2">审核敏感词</a-select-option>
          <a-select-option value="3">敏感词黑名单</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="业务"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      ><a-checkbox-group v-model="newData.bussdepType">
        <a-checkbox v-for="item in bussdepType" :value="item.value" :key="item.id">{{ item.value }}&nbsp;&nbsp;</a-checkbox>
      </a-checkbox-group>
      </a-form-item>
    </a-modal>
  </div>
</template>

<script>
  // import Config from "../../utils/config";
  // import UserRouteTool from "../../utils/userRouteTool";
  import { mapActions, mapGetters } from 'vuex'
  import { timeFix } from '@/utils/util'
  import { bussdepType,filterBussdepType } from '@/config/public'
  import { depList } from '@/api/common'
import { updateItem, removeItem, queryList,addItem,batchadd } from '@/api/keyWords'

  var searchData = {
    bussdepType:'',
    type:'',
    subtype:'',
    keyword:'',
    bussdepid:'',
    nickName:''
  }
  var searchData1 = {
    subtype:'4',
    keyword:'',
    bussdepid:''
  }

  var newData = {
    keyword:'',
    type:'1',
    subtype:'1',
    bussdepType:[],
  }
  export default {
    name: 'KeyWords',
    components: {},
    data() {
      return {
        searchData:JSON.parse(JSON.stringify(searchData)),
        pagination:{
          pageSize:20,
          total:0,
          showTotal:total => `总共 ${total} 条`,
          current:1
        },
        searchData1:JSON.parse(JSON.stringify(searchData1)),
        pagination1:{
          pageSize:20,
          total:0,
          showTotal:total => `总共 ${total} 条`,
          current:1
        },
        chooseId:'0',
        newData:newData,
        originList:[],
        bussdepType:bussdepType,
        filterBussdepType:filterBussdepType,
        loading:false,
        loading1:false,
        chooseItem:{},
        visible1:false,
        businssDept:[],
        userList:[],
        userList1:[]
      }
    },
    created() {

    },
    mounted() {
      if(window.environment == 'bz'){
        this.bussdepType =  bussdepType.filter(item=>item.value==='投教')
      }
      this.getList()
      this.getList1()
      if (this.userInfo().role=='ROLE_SYSTEM') {
        depList().then(res => {
          if (res.code == 1) {
            if(window.environment == 'bz'){
              this.businssDept = res.result.filter(item=>item.name=='博众事业部')
            }else{
              this.businssDept = res.result
            }
          }
        })
      }
    },
    methods: {
      ...mapGetters(['userInfo']),
      filterScope:function(type){
        if (type==1){
          return '敏感词白名单'
        } else if (type==2){
          return '审核敏感词'
        } else if (type==3){
          return '敏感词黑名单'
        }else if (type==0){
          return ''
        }
      },
      chooseFile:function(e){
        var file = e.target.files[0]
        var commonFileExtension=/\.(xls|xlsx)$/i,commonFileSize=10

        if(!commonFileExtension.test(file.name)){
          alert('仅支持excel文件')
          return
        }

        if(file.size>commonFileSize*1024*1024){
          alert('请保证上传的文件在'+commonFileSize+'以内')
          return
        }
        this.upload(file).then(res=>{
          if(res.code == 1){
            this.$message.success('上传成功')
            this.getList()
          }
        })
        e.target.value = null
      },
      upload:function(file){
        var formData = new FormData()
        formData.append('file', file)
        return batchadd(formData)
      },
      edit:function(item){
        this.chooseItem = item
        item.bussdepType = []
        item.bussdeptypeList.forEach(itemm=>{
          item.bussdepType.push(String(itemm.busstype))
        })
        this.newData = JSON.parse(JSON.stringify(item))
        this.newData.type = String(this.newData.type)
        this.newData.subtype = String(this.newData.subtype||1)
        this.visible1 = true
      },
      deleteOne:function(id){
        removeItem({id}).then(res=>{
          if (res.code==1){
            this.$message.success('操作成功')
            this.getList()
            this.getList1()
          }
        })
      },
      mergeBuss(list){
        var str = ''
        if (list instanceof Array){
          list.forEach(item=>{
            str += item.busstype + '/'
          })
        }
        return str
      },
      handleOk1(){
        if (!this.newData.keyword){
          this.$message.error('uid必填')
          return
        }
        if (this.newData.bussdepType.length==0){
          this.$message.error('业务必填')
          return
        }
        var params = JSON.parse(JSON.stringify(this.newData))
        params.bussdepType = params.bussdepType.join('/')
        if (params.type==2) params.subtype=''
        if(this.chooseItem.id){
          updateItem(params).then(res => {
            if(res.code==1){
              this.$message.success('操作成功')
              this.visible1 = false
              this.getList()
            }
          })
        }else{
          addItem(params).then(res => {
            if(res.code==1){
              this.$message.success('操作成功')
              this.visible1 = false
              this.getList()
            }
          })
        }
      },
      addNew(){
        this.chooseItem = {}
        this.visible1 = true
        this.newData = JSON.parse(JSON.stringify(newData))
      },
      reset(){
        this.searchData = JSON.parse(JSON.stringify(searchData))
      },
      reset1(){
        this.searchData1 = JSON.parse(JSON.stringify(searchData1))
      },
      getList(){
        var params = JSON.parse(JSON.stringify(this.searchData))
        params.page = this.pagination.current - 1
        params.size = this.pagination.pageSize
        if (params.type!=1)delete params.subtype
        this.loading = true
        queryList(params).then(res=>{
          if (res.code==1 && res.result && res.result.content){
            this.userList = res.result.content
            this.pagination.total = res.result.totalElements
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      getList1(){
        var params = JSON.parse(JSON.stringify(this.searchData1))
        params.page = this.pagination1.current - 1
        params.size = this.pagination1.pageSize
        this.loading1 = true
        queryList(params).then(res=>{
          if (res.code==1 && res.result && res.result.content){
            this.userList1 = res.result.content
            this.pagination1.total = res.result.totalElements
          }
        }).finally(()=>{
          this.loading1 = false
        })
      },
      handleOk(){

      },
      search(){
        this.pagination.current = 1
        this.getList()
      },
      search1(){
        this.pagination1.current = 1
        this.getList1()
      },
      handleTableChange (pagination) {
        const pager = { ...this.pagination }
        pager.current = pagination.current
        this.pagination = pager
        this.getList()
      },
      handleTableChange1 (pagination) {
        const pager = { ...this.pagination1 }
        pager.current = pagination.current
        this.pagination1 = pager
        this.getList1()
      },
    }
  }
</script>

<style lang="less" scoped>
  .keyWords{
    padding:10px
  }
  .headDiv{
    padding: 20px;
    /*margin: 10px;*/
    input{
      width: 200px;
    }
  }
  .select{
    width:200px;
  }
  .ant-form-item{
    margin-bottom: 0;
  }
</style>